import { render, staticRenderFns } from "./DocumentListRow.vue?vue&type=template&id=fa08ddfc&scoped=true&"
import script from "./DocumentListRow.vue?vue&type=script&lang=ts&"
export * from "./DocumentListRow.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentListRow.vue?vue&type=style&index=0&id=fa08ddfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa08ddfc",
  null
  
)

export default component.exports